import type { App } from '@grafikr/components';

import Cart from 'utils/cart';

export default ({ context }: App) => {
  const getCart = (event?: Event) => {
    Cart.get({
      success: (body) => {
        theme.cart = body;
        context.dispatchEvent('cart:fetched', body);

        // After cart is fetched, handle UI actions based on source
        if (event && event instanceof CustomEvent) {
          const source = event.detail?.source;
          if (source === 'product-page') {
            context.dispatchEvent('cart:drawer:open', null);
          } else if (source === 'quick-add') {
            context.dispatchEvent('cart:notification:open', event.detail);
          }
        }
      },
    });
  };

  // Listen to any cart modifications to update state
  document.addEventListener('cart:added', getCart);
  document.addEventListener('cart:updated', getCart);
};
